/****************
 * AN href BUILT FROM SOMEBODY ELSE'S DATA IS ONLY A WEB ADDRESS.
 *
 * News headlines link to whatever their RSS feed says, and React 18 renders a
 * javascript: URL in an href (it only warns in development), so one crafted
 * item in one feed was a script in every signed-in session on click
 * (2026-10-25). The server drops such links now (safeNewsLink); this is the
 * same rule at the page, for anything already cached and anything next.
 *
 * Returns the URL if it is absolute http(s) with a host, otherwise undefined,
 * so the caller renders the text unlinked.
 ****************/
export function safeHref(value: string | null | undefined): string | undefined {
  if (!value) return undefined;
  let u: URL;
  try {
    u = new URL(value.trim());
  } catch {
    return undefined;
  }
  if (u.protocol !== 'https:' && u.protocol !== 'http:') return undefined;
  if (!u.hostname || u.username || u.password) return undefined;
  return u.toString();
}
